import React from "react";
import { formattedAmount } from "../../../../utils/helpers/Functions.helper";

const DeliveryFeeData = ({ProductDeatils, data }) => {
  if (data) {
    return (
      <div id="invoice-POS" className="printable">
        <center id="top">
          <div className="logo"></div>
          <div className="info">
            <h2>e-Delivery</h2>
          </div>
          <hr />
        </center>

        <div id="mid">
          <div className="info">
            <h3>Delivery Fee Details</h3>
          </div>
        </div>

        <div id="bot">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Details</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan={3} className="text-center font-bold py-1">
                  Delivery Factor
                </td>
              </tr>
              {data.deliveryMan?.factor?.map((factor, index) => (
                <React.Fragment key={index}>
                  <tr>
                    <td>Factor Type</td>
                    <td></td>
                    <td className="text-right">{factor?.name}</td>
                  </tr>
                  <tr>
                    <td>Factor Value</td>
                    <td></td>
                    <td className="text-right">{formattedAmount(factor?.value)}</td>
                  </tr>
                </React.Fragment>
              ))}
              <tr>
                <td>Delivery Man Total</td>
                <td></td>
                <td className="text-right">{formattedAmount(data.deliveryMan?.total)}</td>
              </tr>

              <tr>
                <td colSpan={3} className="text-center font-bold py-1">
                  Admin Charges
                </td>
              </tr>
              <tr>
                <td>Server Handling Fee</td>
                <td></td>
                <td className="text-right">{formattedAmount(data.adminEarning?.shippingHandlingFeeFixedRate)}</td>
              </tr>
              <tr>
                <td>Shipping Fee Rate</td>
                <td className="text-right">{data.adminEarning?.shippingFeeRate?.percentage}%</td>
                <td className="text-right">{formattedAmount(data.adminEarning?.shippingFeeRate?.amount)}</td>
              </tr>

              <tr>
                <td colSpan={3} className="text-center font-bold py-1">
                  Delivery Charges
                </td>
              </tr>

              <tr>
                <th className="text-right" colSpan={2}>Taxable Amount</th>               
                <th className="text-right">{formattedAmount(data.taxableAmount)}</th>
              </tr>

              <tr>
                <td>{data.vat?.name}</td>
                <td className="text-right">{data.vat?.rate}%</td>
                <td className="text-right">{formattedAmount(data.vat?.taxAmount)}</td>
              </tr>

              <tr>
                <th className="text-right" colSpan={2}>Total Delivery Fee</th>
                
                <th className="text-right">{formattedAmount(data.totalDeliveryFee)}</th>
              </tr>
              <tr>
                <th className="text-right" colSpan={2}>Product Net Total:</th>                
                {/* <th className="text-right">{formattedAmount(parseFloat(ProductDeatils?.price?.$numberDecimal || ProductDeatils?.price).toFixed(2) )}</th> */}
                <th className="text-right"> {formattedAmount(((+ProductDeatils?.product?.taxData?.grandTotal?.$numberDecimal || +ProductDeatils?.product?.taxData?.grandTotal)*(+ProductDeatils?.quantity)))}</th>
              </tr>
              <tr>
                <th className="text-right" colSpan={2}>Grand Total:</th>                
                <th className="text-right"> {formattedAmount(((+ProductDeatils?.product?.taxData?.grandTotal?.$numberDecimal || +ProductDeatils?.product?.taxData?.grandTotal)*(+ProductDeatils?.quantity))+(+ProductDeatils?.delivery_fee?.totalDeliveryFee))}</th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
  return null;
};

export default DeliveryFeeData;
